import {defaultSelectedDateFrom, defaultSelectedDateUp} from "./state";

export function setBranchOffices(state, branchOffices){
    state.branchOffices = branchOffices.data;
    state.branchOffices_out = branchOffices.data;
}
export function setBranchOfficesWarehouses(state, branchoffice_warehouses){
    state.branchoffice_warehouses = branchoffice_warehouses;
    state.branch_office_warehouse_id = null;
}
export function setBranchOfficesWarehousesOut(state, branchoffice_warehouses_out){
    state.branchoffice_warehouses_out = branchoffice_warehouses_out;
    state.branch_office_warehouse_id_out = null;
}
export function setReportTransfers(state, data){
    state.reportTransfer = data;
}
export function setDocumentsProductsTransfer(state, data){
    state.documents_products = data;
}
export function clearParams(state, data){
    state.params= {
        branch_office_id: Number(localStorage.selected_branchoffice),
        branch_office_warehouse_id: Number(localStorage.selected_branchoffice_warehouse),
        branch_office_id_out:null,
        branch_office_warehouse_id_out: null,
    }
}




// WEBPACK FOOTER //
// ./src/modules/report-transfers/mutations.js